import DocumentsContents from './DocumentsContents';

export default DocumentsContents;
